import { LimitedTermUnit } from '@platform-frontend/checkout-drop-in';

export interface LicenseValidityChooserRelativeDateConstraint {
  unit: LimitedTermUnit;
  runtime: number;
}
